import type { Infer } from 'superstruct';
import { array, object, optional } from 'superstruct';

import { EditPermissionsDto } from '@adflow/shared/util-data';
import { ViewRoleDto } from '@adflow/shared/util-roles';
import {
	email,
	parsableBoolean,
	userString,
} from '@adflow/shared/util-superstruct';

export const EditUserFormDto = object({
	name: userString('validations:Required'),
	email: email(),
	superuser: optional(parsableBoolean()),
	permissions: EditPermissionsDto,
	roles: optional(array(ViewRoleDto)),
});

export type EditUserFormDto = Infer<typeof EditUserFormDto>;
